import { Injectable } from '@angular/core';

import UserService from './user.service';

@Injectable()
export default class MockUserService extends UserService {
  override getGadId(): string | undefined {
    return 'MOCKUSER';
  }
}
